import { useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  Button,
  Dropdown,
  Form,
  Icon,
  Input,
  Modal,
  Select,
} from "semantic-ui-react";
import { preAuthComp } from "services/payment";

const noError = {
  search: "",
  bookingNumber: "",
  appcode: "",
  amount: "",
};
export default function PreAuthCompPopup(props: any): JSX.Element {
  const {
    popup,
    setPopup,
    loading,
    setLoading,
    setBookingFilter,
    preAuth = {},
    setPreAuth,
    fetchCount,
    setFetchCount,
    hotel,
  } = props;
  // const [loading, setLoading] = useState(false)
  const [error, setError] = useState(noError);

  const capturePreAuthComp = async () => {
    try {
      setLoading((loading: boolean) => true);
      const { bookingNumber, amount, deviceId } = preAuth;

      await preAuthComp({
        bookingNumber,
        amount,
        deviceId,
        currency: "HKD",
        id: preAuth._id,
      });

      setLoading((loading: boolean) => false);
      setPopup({ ...popup, preAuthComp: false, originalAmount: null });

      setError({ ...noError });
      setFetchCount(fetchCount + 1);
    } catch (err: any) {
      console.log(err.message);
      setError({ ...error, search: err?.message?.syscall || err?.message });
      setLoading((loading: boolean) => false);
    }
  };

  return (
    <Modal
      size="mini"
      onClose={() =>
        setPopup({ ...popup, preAuthComp: false, originalAmount: null })
      }
      open={popup.preAuthComp}
    >
      <Modal.Header className="text-left">
        <div>
          <span>Pre-Auth Comp</span>
        </div>
      </Modal.Header>
      <Modal.Content className="text-left">
        {error.search ? (
          <div style={{ color: "red", textAlign: "center" }}>
            {error.search}
          </div>
        ) : (
          ""
        )}
        <Form>
          <Form.Group widths="equal">
            <Form.Input
              width={8}
              label="Booking Number"
              // error={!!error.bookingNumber}
              fluid
              name="bookingNumber"
              placeholder="Booking Number"
              value={preAuth.bookingNumber}
              // onChange={(e, data) => setPreAuth({ ...preAuth, [data.name]: data.value })}
            />
          </Form.Group>

          {/* <Form.Group widths='equal'>
            <Form.Input
              label='App Code'
              // error={!!error.appcode}
              fluid
              name="appcode"
              placeholder="App Code"
              value={preAuth.appcode}
              // onChange={(e, data) => setPreAuth({ ...preAuth, [data.name]: data.value })}
            />
          </Form.Group> */}

          <Form.Group widths="equal">
            <Form.Field>
              <label>Amount</label>
              {!error.amount ? (
                <></>
              ) : (
                <span style={{ color: "red" }}>{error.amount}</span>
              )}
              <NumericFormat
                thousandSeparator=","
                prefix={"$ "}
                name="amount"
                placeholder="Amount"
                // value={preAuth.amount}
                onValueChange={(values: any, sourceInfo: any) => {
                  const { name } = sourceInfo.event.target;
                  const { floatValue } = values;
                  // console.log({name,floatValue})
                  setPreAuth({ ...preAuth, [name]: floatValue });
                }}
              />
            </Form.Field>
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => {
            setPopup({
              ...popup,
              preAuthComp: false,
              originalAmount: null,
            });
          }}
        >
          Close
        </Button>
        <Button
          disabled={loading}
          loading={loading}
          content={"Submit"}
          // icon='plus'
          onClick={async () => {
            // console.log({ preAuth })
            const checkErrors = Object.keys(error).reduce(
              (acc: any, key: string) => {
                if (key === "search") return acc;

                if (key === "amount" && preAuth.amount > popup.originalAmount)
                  acc[
                    key
                  ] = `entered amount cannot more than ${popup.originalAmount}`;
                else if (
                  Array.isArray(preAuth[key]) &&
                  preAuth[key].length === 0
                )
                  acc[key] = "required";
                else if (!preAuth[key]) acc[key] = "required";
                else acc[key] = "";
                return acc;
              },
              {}
            );

            const hasMissing = Object.values(checkErrors).some((err) => !!err);

            // console.log(checkErrors)
            if (hasMissing) {
              setError({ ...checkErrors });
              return;
            }

            await capturePreAuthComp();
          }}
          color="yellow"
        />
      </Modal.Actions>
    </Modal>
  );
}
